// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"11741ec3","211":"b04d7216","324":"28a8bdc3","854":"99b6b127"}[chunkId] + ".css";
};